// extracted by mini-css-extract-plugin
module.exports = {"block-search":"Search_block-search__3_zHr","field":"Search_field__2LjI7","close":"Search_close__2WyuN"};